import { ApiProvider, PaginatedResult } from "@/providers/api-provider";
import { i18n } from "@/main";
import { MessageType } from "@/components/_shared/template/app-snackbar.vue";

class AppUpdatesApiProvider extends ApiProvider {
  async getAll(params: URLSearchParams): Promise<PaginatedResult> {
    const response = await this.get(`/app-updates?${params}`);
    return response ? response : [];
  }

  async create(update: any) {
    const response = await this.post(`/app-update`, { ...update }, [
      { type: MessageType.success, text: i18n.t("message.updates_created").toString() },
      { type: MessageType.error, text: i18n.t("message.updates_created_error").toString() },
    ]);
    return response ? response.data : null;
  }

  async remove(update: any) {
    const response = await this.delete(`/app-update/${update.id}`);
    return response.data;
  }
}

export const appUpdatesApiProvider = new AppUpdatesApiProvider();
